import ApiService from '../../../../shared/services/ApiService';

export default{
    getFavoriteLocations(){
        return ApiService.get('favorite-locations');
    },
    updateLocation(id, data){
        return ApiService.put(`favorite-locations/${id}`, data)
    },
    newFavoriteLocations(data){
        return ApiService.post('favorite-locations', data);
    },
    searchLocations(query){
        return ApiService.get(`search-location?q=${query}`);
    },
    deleteSite(id){
        return ApiService.delete(`favorite-locations/${id}`);
    },

    updateCompanySettings(data){
        return ApiService.post('company-settings', data);
    },
    radiusOptions(){
        return [
            {
                value: "200",
                label: "200",
            },
            {
                value: "400",
                label: "400",
            },
            {
                value: "600",
                label: "600",
            },
            {
                value: "800",
                label: "800",
            },
            {
                value: "1000",
                label: "1000",
            },
            {
                value: "1200",
                label: "1200",
            },
            {
                value: "1400",
                label: "1400",
            },
            {
                value: "1600",
                label: "1600",
            },
            {
                value: "1800",
                label: "1800",
            },
            {
                value: "2000",
                label: "2000",
            },
        ]
    },
}